import { CHAT_MESSAGE_TYPES } from 'features/chat/config';
import {
  CoachingSessionRecapMessageContent,
  DeletedMessageContent,
  MessageContentBasedOnType,
  MorpheusMessageContent,
  MorpheusSuggestionsContent,
  PlainMessageContent,
  SystemMessageContent,
  WidgetsContent,
} from 'features/chat/config/types/Message';

export const isChatMessageDeletedType = (
  content: MessageContentBasedOnType
): content is DeletedMessageContent =>
  content.type === CHAT_MESSAGE_TYPES.DELETED;

export const isChatMessageSystemType = (
  content: MessageContentBasedOnType
): content is SystemMessageContent =>
  content.type === CHAT_MESSAGE_TYPES.SYSTEM;

export const isChatMessageSessionRecapType = (
  content: MessageContentBasedOnType
): content is CoachingSessionRecapMessageContent =>
  content.type === CHAT_MESSAGE_TYPES.COACHING_SESSION_RECAP;

export const isChatMessagePlainType = (
  content: MessageContentBasedOnType
): content is PlainMessageContent => content.type === CHAT_MESSAGE_TYPES.PLAIN;

export const isChatMessageWidgetsType = (
  content: MessageContentBasedOnType
): content is WidgetsContent => content.type === CHAT_MESSAGE_TYPES.WIDGETS;

export const isChatMessageMorpheusSuggestionsType = (
  content: MessageContentBasedOnType
): content is MorpheusSuggestionsContent =>
  content.type === CHAT_MESSAGE_TYPES.MORPHEUS_SUGGESTION;

export const isChatMessageMorpheusType = (
  content: MessageContentBasedOnType
): content is MorpheusMessageContent =>
  content.type === CHAT_MESSAGE_TYPES.MORPHEUS;
